import { getStoredLanguage, DEFAULT_LANGUAGE } from '../config/languageConfig';

export async function fetchWithLanguage(url, options = {}) {
    const userLanguage = getStoredLanguage() || DEFAULT_LANGUAGE;

    const headers = {
        ...options.headers,
        'X-User-Language': userLanguage
    };

    return fetch(url, { ...options, headers });
} 